import { ConfigurationTypes } from '../const/ConfigurationTypes';
import ConfigManager from '../managers/ConfigManager';
import IBuyFeatureConfig from '../managers/contracts/configurations/IBuyFeatureConfig';
import IBuyFeatureData from '../server/data/IBuyFeatureData';
import { BaseModel } from "./BaseModel";
class BuyFeatureModel extends BaseModel<IBuyFeatureData> {
    public buyFeature: boolean = false;
    public hasBuyFeatureIsTriggered: boolean = false;
    public isInBuyFeatureFreeSpins: boolean = false;
    public validBets: number[] = [];
    public currentBetIndex: number = 0;
    public getBet(): number {
        return this.validBets[this.currentBetIndex]
    }
    public getTotalBet = () => {
        let config = ConfigManager.getConfig(ConfigurationTypes.BUY_FEATURE);
        let currentBet = this.validBets[this.currentBetIndex];
        return config.betMultiplier * currentBet
    }
}

export default new BuyFeatureModel()
